import { setSliders } from '../actions';
import { identityPayload, createReducer, forAction } from '../utils';

const initialState = [];

export default createReducer(
  [forAction(setSliders, identityPayload)],
  initialState,
);
